import { map, Observable, shareReplay, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { USER_DATA_TOKEN, UserDataProvider, UserModel } from '@core';
import { UnreadMessagesService } from '@messages/infra';
import { UnreadMessagesDTO } from '../../../../infrastructure/dto';

export class UnreadMessagesQueryHandler {
  private readonly unreadMessagesService: UnreadMessagesService = inject(UnreadMessagesService);
  private readonly userDataProvider: UserDataProvider = inject(USER_DATA_TOKEN);

  readonly unreadMessages$: Observable<UnreadMessagesDTO[]> = this.userDataProvider.userData$.pipe(
    switchMap((userData: UserModel) => this.unreadMessagesService.unreadCount(userData.userId)),
    shareReplay(1)
  );

  isUnreadMessage(): Observable<boolean> {
    return this.unreadMessages$.pipe(
      map((channels: UnreadMessagesDTO[]) =>
        channels.some((channel: UnreadMessagesDTO) => channel.newMessageAt > channel.readAt || !channel.readAt)
      )
    );
  }
}
